import { render, staticRenderFns } from "./BatchList.vue?vue&type=template&id=c6e91446&scoped=true"
import script from "./BatchList.vue?vue&type=script&lang=ts"
export * from "./BatchList.vue?vue&type=script&lang=ts"
import style0 from "./BatchList.vue?vue&type=style&index=0&id=c6e91446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e91446",
  null
  
)

export default component.exports